module.exports = __webpack_public_path__ + "img/deplacement.556039cd.webp";